import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bc0908c0&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc0908c0')) {
      api.createRecord('bc0908c0', component.options)
    } else {
      api.reload('bc0908c0', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=bc0908c0&", function () {
      api.rerender('bc0908c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/promotions/Index.vue"
export default component.exports